import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';

class Intermediate extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      responseData:[]
    }
    this.props.queryString.callExtraction();
  }

  componentDidMount(){
    this.props.chAuth.callAuthentication();
  }

  render(){
    const {auth:{ergonError}}=this.props;

    if(ergonError){
        return <div>{{ergonError}}</div>
    }

    return (
      <div>
        <h3>Connect Id Intermediate Page</h3>
      </div>
      );
  }
}

export default createContainer({
  $queries: {
    auth:{
      ergonError:true,
    },
    queryString: { 
      code: true,
      state: true,
      callExtraction: { $call: 'extract' },
    },
    chAuth:{
      callAuthentication: { $call: 'login' },
    }
  }
})(Intermediate);


